<template>
  <div>
    <div class="ma-page-head">
      <div>
        <h1 class="ma-page-title">
          {{ cfg.title }}
        </h1>
        <p class="ma-page-sub">
          {{ cfg.sub }}
        </p>
      </div>
      <button
        class="ma-btn ma-btn-primary"
        @click="openCreate"
      >
        <feather-icon
          icon="PlusIcon"
          size="16"
        />
        {{ cfg.cta }}
      </button>
    </div>

    <div class="ma-toolbar">
      <select
        v-model="levelFilter"
        class="ma-select"
      >
        <option value="">
          Tous les niveaux
        </option>
        <option
          v-for="l in levels"
          :key="l"
          :value="l"
        >
          {{ l }}
        </option>
      </select>
    </div>

    <div
      v-if="loading"
      class="ma-loading"
    >
      Chargement…
    </div>

    <div
      v-else-if="!filtered.length"
      class="ma-card ma-empty"
    >
      <div class="ma-empty-ico">
        <feather-icon
          :icon="cfg.icon"
          size="30"
        />
      </div>
      <h4>{{ items.length ? 'Aucun résultat' : cfg.emptyTitle }}</h4>
      <p>{{ items.length ? 'Ajuste le filtre de niveau.' : cfg.emptyText }}</p>
    </div>

    <div
      v-else
      class="fs-list"
    >
      <div
        v-for="item in filtered"
        :key="item._id"
        class="fs-row"
      >
        <div
          class="fs-ico"
          :class="kind"
        >
          <feather-icon
            :icon="rowIcon(item)"
            size="20"
          />
        </div>
        <div class="fs-info">
          <h4>{{ item.title }}</h4>
          <div class="fs-tags">
            <span class="ma-badge level">{{ item.level }}</span>
            <span
              v-if="item.subject"
              class="ma-badge subject"
            >{{ item.subject }}</span>
          </div>
          <p
            v-if="item.description"
            class="fs-desc"
          >
            {{ item.description }}
          </p>
          <p
            v-if="kind === 'link'"
            class="fs-url"
          >
            {{ item.url }}
          </p>
        </div>
        <div class="fs-actions">
          <a
            v-if="kind === 'link'"
            :href="item.url"
            target="_blank"
            rel="noopener"
            class="ma-btn ma-btn-ghost"
          >
            <feather-icon
              icon="ExternalLinkIcon"
              size="15"
            />
            Ouvrir
          </a>
          <a
            v-else-if="item.file && item.file.fileUrl"
            :href="apiBase + item.file.fileUrl"
            target="_blank"
            rel="noopener"
            class="ma-btn ma-btn-ghost"
          >
            <feather-icon
              icon="ExternalLinkIcon"
              size="15"
            />
            Ouvrir
          </a>
          <button
            class="fs-del"
            title="Supprimer"
            @click="remove(item)"
          >
            <feather-icon
              icon="Trash2Icon"
              size="16"
            />
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="showModal"
      class="ma-modal-backdrop"
      @click.self="showModal = false"
    >
      <div class="ma-modal">
        <div class="ma-modal-head">
          <h3 class="ma-modal-title">
            {{ cfg.cta }}
          </h3>
          <p class="ma-modal-sub">
            {{ cfg.modalSub }}
          </p>
        </div>
        <div class="ma-modal-body">
          <div class="ma-field">
            <label>Titre <span class="req">*</span></label>
            <input
              v-model="form.title"
              class="ma-input"
              type="text"
              :placeholder="cfg.titlePlaceholder"
            >
          </div>

          <div class="ma-row">
            <div class="ma-field">
              <label>Niveau <span class="req">*</span></label>
              <select
                v-model="form.level"
                class="ma-input"
              >
                <option value="">
                  — Choisir —
                </option>
                <option
                  v-for="l in levels"
                  :key="l"
                  :value="l"
                >
                  {{ l }}
                </option>
              </select>
            </div>
            <div
              v-if="kind !== 'link'"
              class="ma-field"
            >
              <label>Matière</label>
              <select
                v-model="form.subject"
                class="ma-input"
              >
                <option value="">
                  — Optionnel —
                </option>
                <option
                  v-for="s in subjects"
                  :key="s"
                  :value="s"
                >
                  {{ s }}
                </option>
              </select>
            </div>
          </div>

          <div
            v-if="kind === 'link'"
            class="ma-field"
          >
            <label>Lien <span class="req">*</span></label>
            <input
              v-model="form.url"
              class="ma-input"
              type="url"
              placeholder="https://www.facebook.com/groups/…"
            >
          </div>

          <div
            v-else
            class="ma-field"
          >
            <label>Fichier PDF <span class="req">*</span></label>
            <input
              ref="fileInput"
              class="ma-input"
              type="file"
              accept="application/pdf"
              @change="onFile"
            >
            <small
              v-if="pdfFile"
              style="color:var(--ma-muted);font-size:0.78rem;"
            >{{ pdfFile.name }}</small>
          </div>

          <div class="ma-field">
            <label>Description</label>
            <textarea
              v-model="form.description"
              class="ma-input"
              rows="3"
              placeholder="Optionnel"
            />
          </div>

          <p
            v-if="error"
            style="display:flex;align-items:center;gap:8px;color:#DC2626;background:#FEF2F2;padding:10px 14px;border-radius:10px;font-size:0.85rem;font-weight:600;"
          >
            {{ error }}
          </p>
        </div>
        <div class="ma-modal-foot">
          <button
            class="ma-btn ma-btn-ghost"
            @click="showModal = false"
          >
            Annuler
          </button>
          <button
            class="ma-btn ma-btn-primary"
            :disabled="saving"
            @click="create"
          >
            <span
              v-if="saving"
              class="ma-loader"
            />
            <span v-else>Publier</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import axios from '@axios'
import { LEVELS, SUBJECTS } from './constants'

const KINDS = {
  link: {
    title: 'Liens utiles',
    sub: 'Ajoutez des groupes Facebook et d’autres liens, ciblés par niveau.',
    cta: 'Nouveau lien',
    emptyTitle: 'Aucun lien',
    emptyText: 'Ajoutez le premier groupe Facebook ou lien utile.',
    modalSub: 'Indiquez un niveau et l’URL à partager aux étudiants.',
    titlePlaceholder: 'Ex : Groupe Facebook 1A',
    icon: 'LinkIcon',
  },
  drive: {
    title: 'Drive',
    sub: 'Déposez les cours en PDF. Chaque étudiant voit ceux de son niveau.',
    cta: 'Ajouter un PDF',
    emptyTitle: 'Aucun document',
    emptyText: 'Ajoutez le premier cours PDF.',
    modalSub: 'Choisissez un niveau puis importez le fichier PDF.',
    titlePlaceholder: 'Ex : Cours Analyse — chapitre 1',
    icon: 'FolderIcon',
  },
  exam: {
    title: 'Examens corrigés',
    sub: 'Publiez les examens corrigés par niveau.',
    cta: 'Ajouter un examen',
    emptyTitle: 'Aucun examen',
    emptyText: 'Ajoutez le premier examen corrigé.',
    modalSub: 'Choisissez un niveau puis importez le PDF corrigé.',
    titlePlaceholder: 'Ex : Examen Algo 2025 — corrigé',
    icon: 'FileTextIcon',
  },
}

export default {
  name: 'MindsAdminResources',
  data() {
    return {
      apiBase: process.env.VUE_APP_API_URL || '',
      items: [],
      loading: true,
      levelFilter: '',
      levels: LEVELS,
      subjects: SUBJECTS,
      showModal: false,
      form: {
        title: '', level: '', subject: '', url: '', description: '',
      },
      pdfFile: null,
      saving: false,
      error: '',
    }
  },
  computed: {
    kind() {
      return (this.$route.meta && this.$route.meta.kind) || 'link'
    },
    cfg() {
      return KINDS[this.kind] || KINDS.link
    },
    filtered() {
      if (!this.levelFilter) return this.items
      return this.items.filter(s => s.level === this.levelFilter)
    },
  },
  watch: {
    kind() {
      this.levelFilter = ''
      this.fetch()
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    rowIcon(item) {
      if (this.kind === 'link') {
        return this.isFacebook(item.url) ? 'UsersIcon' : 'LinkIcon'
      }
      return this.cfg.icon
    },
    isFacebook(url) {
      return /facebook\.com/i.test(String(url || ''))
    },
    async fetch() {
      this.loading = true
      try {
        const res = await axios.get('/ma/admin/resources', { params: { kind: this.kind } })
        this.items = res.data.resources || []
      } catch (e) {
        this.items = []
      } finally {
        this.loading = false
      }
    },
    onFile(e) {
      const f = e.target.files && e.target.files[0]
      this.pdfFile = f || null
    },
    openCreate() {
      this.form = {
        title: '', level: '', subject: '', url: '', description: '',
      }
      this.pdfFile = null
      this.error = ''
      this.showModal = true
    },
    async create() {
      if (this.saving) return
      if (!this.form.title.trim()) { this.error = 'Le titre est requis.'; return }
      if (!this.form.level) { this.error = 'Le niveau est requis.'; return }
      if (this.kind === 'link' && !this.form.url.trim()) {
        this.error = 'Le lien est requis.'; return
      }
      if (this.kind !== 'link' && !this.pdfFile) {
        this.error = 'Le fichier PDF est requis.'; return
      }
      this.saving = true
      this.error = ''
      try {
        let res
        if (this.kind === 'link') {
          res = await axios.post('/ma/admin/resources', {
            kind: 'link',
            title: this.form.title.trim(),
            level: this.form.level,
            description: this.form.description || '',
            url: this.form.url.trim(),
          })
        } else {
          const fd = new FormData()
          fd.append('kind', this.kind)
          fd.append('title', this.form.title.trim())
          fd.append('level', this.form.level)
          fd.append('subject', this.form.subject || '')
          fd.append('description', this.form.description || '')
          fd.append('file', this.pdfFile)
          res = await axios.post('/ma/admin/resources', fd)
        }
        this.items.unshift(res.data.resource)
        this.showModal = false
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.error) || 'Publication impossible.'
      } finally {
        this.saving = false
      }
    },
    async remove(item) {
      // eslint-disable-next-line no-alert
      if (!window.confirm(`Supprimer « ${item.title} » ?`)) return
      try {
        await axios.delete(`/ma/admin/resources/${item._id}`)
        this.items = this.items.filter(x => x._id !== item._id)
      } catch (e) {
        // eslint-disable-next-line no-alert
        window.alert((e.response && e.response.data && e.response.data.error) || 'Suppression impossible.')
      }
    },
  },
}
</script>

<style src="./minds.css"></style>
<style scoped>
.fs-list { display: flex; flex-direction: column; gap: 12px; }
.fs-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid var(--ma-line);
  border-radius: var(--ma-radius);
  box-shadow: var(--ma-shadow);
}
.fs-ico {
  width: 46px;
  height: 46px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 13px;
}
.fs-ico.link { background: #dbeafe; color: #1d4ed8; }
.fs-ico.drive { background: #e0e7ff; color: #4f46e5; }
.fs-ico.exam { background: #ffedd5; color: #c2410c; }
.fs-info { flex: 1; min-width: 0; }
.fs-info h4 { margin: 0 0 7px; font-size: 1rem; font-weight: 800; }
.fs-tags { display: flex; align-items: center; gap: 7px; flex-wrap: wrap; }
.fs-desc { margin: 8px 0 0; color: var(--ma-muted); font-size: 0.85rem; line-height: 1.45; }
.fs-url {
  margin: 6px 0 0;
  color: #1d4ed8;
  font-size: 0.78rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fs-actions { display: flex; align-items: center; gap: 8px; flex: 0 0 auto; }
.fs-del {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border: 1px solid var(--ma-line);
  border-radius: 11px;
  background: #fff;
  color: var(--ma-muted);
  cursor: pointer;
}
.fs-del:hover { border-color: #fecaca; background: #fff1f2; color: #dc2626; }
@media (max-width: 640px) {
  .fs-row { flex-wrap: wrap; }
  .fs-actions { width: 100%; justify-content: flex-end; }
}
</style>
